<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom:20px;">Dedication</h1>
<p>This book is dedicated to Billy C., a man with a very large heart without whose impossible love this tale could not possibly have been written, for he was the man with the aquamarine-blue eyes.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1f9cd464